import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cashConverter } from "../../../utils";

function BoreholeView({ onClose, open, prodd }) {
  const navigate = useNavigate();

  const items1 = [
    {
      key: "1",
      label: "Name of borehole",
      children: prodd?.bhName ?? "N/A",
    },  
    {
      key: "4",
      label: "Estimated Household",
      children: prodd?.bhEstBeneficiaries ?? "N/A",
    },
    {
      key: "6",
      label: "Start Date",
      children: (
        <div>
          {prodd?.bhStartDate
            ? moment(prodd?.bhStartDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "7",
      label: "End Date",
      children: (
        <div>
          {prodd?.bhEndDate
            ? moment(prodd?.bhEndDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "8",
      label: "Time Frame",
      children: prodd?.bhTimeFrame ?? "N/A",
    },
    {
      key: "8",
      label: "Acreage",
      children: prodd?.bhAcreage ?? "N/A",
    },
    {
      key: "9",
      label: "Remarks",
      children: prodd?.bhRemarks ?? "N/A",
    },

    {
      key: "9",
      label: "Purpose/Water Use",
      children: prodd?.wuType ?? "N/A",
    },
      
    {
      key: "10",
      label: "Livestock",
      children: prodd?.bhLivestockEst ?? "N/A",
    },
  ];
  const items2 = [
    {
      key: "5",
      label: "County",
      children: prodd?.countyCode ?? "N/A",
    },
    {
      key: "1",
      label: "SubCounty",
      children: prodd?.subCountyCode ?? "N/A",
    },
    {
      key: "2",
      label: "Location",
      children: prodd?.locLocation ?? "N/A",
    },
    {
      key: "3",
      label: "SubLocation",
      children: prodd?.slocLocation ?? "N/A",
    },
    {
      key: "45",
      label: "Constituency",
      children: prodd?.constName ?? "N/A",
    },
    {
      key: "4",
      label: "Ward",
      children: prodd?.wdWard ?? "N/A",
    }, 
    {
      key: "2",
      label: "Cost",
      children: <div>{cashConverter(prodd?.bhCost)}</div>,
    },
    {
      key: "8",
      label: "Funding Source",
      children: prodd?.bhSourceFunds ?? "N/A",
    },
   
    {
      key: "11",
      label: "Pathways",
      children: prodd?.bhPathways ?? "N/A",
    },
    {
      key: "12",
      label: "Implementing Agency",
      children: prodd?.bhAgency ?? "N/A",
    },
    {
      key: "13",
      label: "Managing Entity",
      children: prodd?.bhManagingAgency ?? "N/A",
    },
    
  ];
 
  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">bh Infomation</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title=""
          column={1}
          colon={false}
          items={items1}
          layout="vertical"
        />
        <Descriptions
          title=""
          column={1}
          colon={false}
          items={items2}
          layout="vertical"
        />
        
      </div>
    </Drawer>
  );
}

export default BoreholeView;
